import { useState } from 'react';

const AgeVerificationOverlay = ({ onConfirm }) => {
    const [denied, setDenied] = useState(false);

    if (denied) {
        return (
            <div className="age-backdrop">
                <div className="age-modal">
                    <div className="age-modal__icon">🔞</div>
                    <h2 className="age-modal__title">Access Denied</h2>
                    <p className="age-modal__text">
                        You must be 18 years or older to access this site.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="age-backdrop">
            <div className="age-modal">
                <div className="age-modal__icon">🎰</div>
                <h2 className="age-modal__title">Age Verification</h2>
                <p className="age-modal__text">
                    This site contains adult content. Please confirm that you are 18 years of age or older to continue.
                </p>
                <div className="age-modal__divider" />
                <div className="age-modal__btns">
                    <button className="age-btn age-btn--primary" onClick={onConfirm}>
                        I am 18 or older
                    </button>
                    <button className="age-btn age-btn--secondary" onClick={() => setDenied(true)}>
                        Exit Site
                    </button>
                </div>
                <p className="age-modal__disclaimer">
                    Please gamble responsibly. Help available at{' '}
                    <a href="https://www.hjelpelinjen.no" target="_blank" rel="noreferrer">
                        hjelpelinjen.no
                    </a>
                </p>
            </div>
        </div>
    );
};

export default AgeVerificationOverlay;